
export const FieldIsRequared = (text) => {
    if (!text)
        return "Вы ничего не написали :(";
    return undefined
};
export const FieldLength = (lenght) => (text) => {
    if (text && text.length <= lenght)
        return undefined;
    return "Слишком много символов, больно :("
};